<div mat-dialog-content class="loading-dialog-content">
  <loading [loadingIndicator]="data"></loading>
</div>
